/** http 包内使用的公共文案（与 @repo/i18n common 保持一致，仅保留本包引用到的 key） */
export default {
  requestCode: {
    dlsxqcxdl: '登錄失效，請重新登錄',
  },
  tradeDialog: {
    toastFreezeText: '提交失敗！賬戶已凍結，請聯系客服。',
  },
}
